import { createVNode as _createVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4834700a")

_pushScopeId("data-v-4834700a")
const _hoisted_1 = {
  key: 0,
  class: "fixed z-100 inset-0 overflow-hidden"
}
const _hoisted_2 = { class: "absolute inset-0 overflow-hidden" }
const _hoisted_3 = { class: "absolute inset-y-0 right-0 pl-0 md:pl-10 max-w-full flex" }
const _hoisted_4 = { class: "relative w-screen max-w-md" }
const _hoisted_5 = {
  class: "h-full flex flex-col bg-white shadow-xl overflow-y-scroll",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "slideover-content"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Transition, {
    name: "slideover",
    onEnter: _cache[2] || (_cache[2] = $event => (_ctx.showContent = true))
  }, {
    default: _withId(() => [
      (_ctx.show)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", {
                class: "absolute inset-0 bg-black opacity-75",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.closeModal()))
              }),
              _createVNode("section", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode(_Transition, {
                    name: "slideover-panel",
                    "enter-active-class": "animated slideInRight",
                    "leave-active-class": "animated slideOutRight"
                  }, {
                    default: _withId(() => [
                      _withDirectives(_createVNode("div", _hoisted_5, [
                        _renderSlot(_ctx.$slots, "default")
                      ], 512), [
                        [_vShow, _ctx.showContent]
                      ])
                    ]),
                    _: 3
                  })
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})